import { Grid } from "@mui/material";
import Tabs from "Pages/Hiload/components/VehicleViewTabs/Tabs";
import React, { useState } from "react";
import Box from "ReusableComponents/Box";
import { COLORS, SIZES, WEIGHT } from "theme";
import Text from "ReusableComponents/Text";
import { useTranslation } from "react-i18next";
import Van from "../../../../assets/van.png";
import Auto from "../../../../assets/auto.png";
import Hicity from "../../../../assets/hicity.png";
import { useLanguage } from "LanguageContext";

const Products = ({ products, leave, onClick }) => {
    const { t } = useTranslation();
    const { selectedLanguage } = useLanguage();

    const [hover, setHover] = useState(false);
    const handleHover = (id) => {
        setHover(id + 1);
    };

    return (
        <Grid
            container
            spacing={2}
            onMouseLeave={leave}
            style={{
                zIndex: 5,
                position: "absolute",
                top: hover ? "90px" : "110%",
                left: "100px",
                boxShadow: "0px 15px 40px #0000001F",
                maxWidth: "min-content",
                transition: "top 0.5s ease",
            }}
        >
            <Box background={COLORS.white} padding={SIZES.twentyFour}>
                <Grid item xs={12}>
                    <Tabs
                        notMargin
                        fromProducts
                        active={0}
                        isBottomBorder={false}
                        fromHiload
                        // tabs={["Three Wheelers"]}
                    />
                </Grid>

                {products?.map((item, i) => {
                    if (i == 1)
                        return (
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                key={item.id}
                                // style={{
                                //   padding: 10,
                                //   textAlign: "center",
                                //   background:
                                //     hover === item.id + 1 ? COLORS.primary : COLORS.white,
                                // }}
                                // onClick={() => {
                                //   onClick();
                                //   window.location.href = `/${selectedLanguage}/hiload`;
                                // }}
                            >
                                <Box
                                    display="flex"
                                    cursor="pointer"
                                    flexDirection="column"
                                    onMouseEnter={() => handleHover(item.id)}
                                    onMouseLeave={() => handleHover(0)} // Reset hover on mouse leave
                                >
                                    <Box
                                        onClick={() => {
                                            onClick();
                                            window.location.href =
                                                "/storm-ev/LR";
                                        }}
                                        className="hover"
                                        w="300px"
                                        margin="0 auto"
                                        style={{
                                            display: "flex",
                                            gap: "15px",
                                            padding: "0px",
                                            // background:
                                            //   hover === item.id ? COLORS.primary : COLORS.white,
                                        }}
                                    >
                                        <img
                                            src={Van}
                                            // src={item?.attributes?.main_img?.data?.attributes?.url}
                                            // alt={
                                            //   item?.attributes?.main_img?.data?.attributes
                                            //     ?.alternativeText
                                            // }
                                            style={{ width: "115px" }}
                                        />

                                        <Text
                                            fontSize={"20px"}
                                            textColor={COLORS.black}
                                            fontWeight={WEIGHT.bold}
                                            margin={"8px 0"}
                                            style={{ alignSelf: "center" }}
                                        >
                                            {t("StormEV LongRange200")}
                                        </Text>
                                    </Box>

                                    <Box
                                        onClick={() => {
                                            onClick();
                                            window.location.href = "/storm-ev";
                                        }}
                                        className="hover"
                                        w="300px"
                                        margin="0 auto"
                                        style={{
                                            display: "flex",
                                            gap: "15px",
                                            padding: "0px",
                                            // background:
                                            //   hover === item.id + 1 ? COLORS.secondary : COLORS.white,
                                        }}
                                    >
                                        <img
                                            src={Van}
                                            // src={item?.attributes?.main_img?.data?.attributes?.url}
                                            // alt={
                                            //   item?.attributes?.main_img?.data?.attributes
                                            //     ?.alternativeText
                                            // }
                                            style={{ width: "115px" }}
                                        />

                                        <Text
                                            fontSize={"20px"}
                                            textColor={COLORS.black}
                                            fontWeight={WEIGHT.bold}
                                            margin={"8px 0"}
                                            style={{ alignSelf: "center" }}
                                        >
                                            {t("StormEV T1250")}
                                        </Text>
                                    </Box>

                                    <Box
                                        onClick={() => {
                                            onClick();
                                            window.location.href = "/hiload";
                                        }}
                                        className="hover"
                                        w="300px"
                                        margin="0 auto"
                                        style={{
                                            display: "flex",
                                            gap: "15px",
                                            padding: "0px",
                                            // background:
                                            //   hover === item.id + 2 ? COLORS.tertiary : COLORS.white,
                                        }}
                                    >
                                        <img
                                            src={Auto}
                                            // src={item?.attributes?.main_img?.data?.attributes?.url}
                                            // alt={
                                            //   item?.attributes?.main_img?.data?.attributes
                                            //     ?.alternativeText
                                            // }
                                            style={{ width: "115px" }}
                                        />

                                        <Text
                                            fontSize={"20px"}
                                            textColor={COLORS.black}
                                            fontWeight={WEIGHT.bold}
                                            margin={"8px 0"}
                                            style={{ alignSelf: "center" }}
                                        >
                                            {t("HiLoad EV")}
                                        </Text>
                                    </Box>

                                    {/* <Box
                                        onClick={() => {
                                            onClick();
                                            window.location.href = "/hicity";
                                        }}
                                        className="hover"
                                        w="300px"
                                        margin="0 auto"
                                        style={{
                                            display: "flex",
                                            gap: "15px",
                                            padding: "0px",
                                            // background:
                                            //   hover === item.id + 2 ? COLORS.tertiary : COLORS.white,
                                        }}
                                    >
                                        <img
                                            src={Hicity}
                                            // src={item?.attributes?.main_img?.data?.attributes?.url}
                                            // alt={
                                            //   item?.attributes?.main_img?.data?.attributes
                                            //     ?.alternativeText
                                            // }
                                            style={{ width: "115px" }}
                                        />

                                        <Text
                                            fontSize={"20px"}
                                            textColor={COLORS.black}
                                            fontWeight={WEIGHT.bold}
                                            margin={"8px 0"}
                                            style={{ alignSelf: "center" }}
                                        >
                                            {t("HiCity")}
                                        </Text>
                                    </Box> */}
                                </Box>
                            </Grid>
                        );
                })}
            </Box>
        </Grid>
    );
};

export default Products;
